// extracted by mini-css-extract-plugin
module.exports = {"root":"_c6da5d","header":"_6c6377","itemsList":"_79f5a2","item":"_2c125c","active":"_5d3343"};